import { Box, Grid, styled, TextField, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { api } from '../../../api';
import { formatDate } from '../../../util';

interface SummaryInOut {
  total_in_out: number;
  total_in: number;
  total_out: number;
}
interface SummaryNumberInOutProps {
  filterID: string;
  filterName: string;
  filterGateIDList: number[];
  filterAreaIDList: number[];
  filterCompanyIDList: number[];
  filterPersonTypeIDList: string[];
  filterScanTypes: string[];
  filterStartDate: Date | null;
  filterEndDate: Date | null;
}
const SummaryNumberInOut: React.FC<SummaryNumberInOutProps> = ({
  filterID,
  filterName,
  filterGateIDList,
  filterAreaIDList,
  filterCompanyIDList,
  filterPersonTypeIDList,
  filterScanTypes,
  filterStartDate,
  filterEndDate
}: SummaryNumberInOutProps) => {
  const [summary, setSummary] = useState<SummaryInOut>({
    total_in_out: 0,
    total_in: 0,
    total_out: 0
  });

  const summaryData = useMemo(
    () => [
      { title: 'Total', amount: summary.total_in_out },
      { title: 'In', amount: summary.total_in },
      { title: 'Out', amount: summary.total_out }
    ],
    [summary]
  );

  useEffect(() => {
    const searchParams = new URLSearchParams();
    if (filterID) {
      searchParams.set('personal_id', `${filterID}`);
    }
    if (filterName) {
      searchParams.set('name', `${filterName}`);
    }
    if (filterGateIDList) {
      filterGateIDList.forEach((gate_id) => {
        searchParams.append('gate_id', `${gate_id}`);
      });
    }
    if (filterAreaIDList) {
      filterAreaIDList.forEach((area_id) => {
        searchParams.append('area_id', `${area_id}`);
      });
    }
    if (filterCompanyIDList.length) {
      filterCompanyIDList.forEach((company_id) => {
        searchParams.append('company_id', `${company_id}`);
      });
    }
    if (filterPersonTypeIDList.length) {
      filterPersonTypeIDList.forEach((person_type_id) => {
        searchParams.append('person_type_id', `${person_type_id}`);
      });
    }
    if (filterScanTypes.length) {
      filterScanTypes.forEach((type_id) => {
      searchParams.append('type_id', `${type_id}`);
    });
  }
    
    if (filterStartDate) {
      searchParams.set('start_date', `${filterStartDate.toISOString()}`);
    }
    if (filterEndDate) {
      searchParams.set('end_date', `${filterEndDate.toISOString()}`);
    }
    api.get<SummaryInOut>(`/summary-in-out`, { params: searchParams }).then((res) => {
      const { data } = res;
      setSummary(data);
    });
  }, [
    filterID,
    filterName,
    filterGateIDList,
    filterAreaIDList,
    filterCompanyIDList,
    filterPersonTypeIDList,
    filterScanTypes,
    filterStartDate,
    filterEndDate
  ]);

  return (
    <Box>
      <Grid container>
        {summaryData.map((item, index) => (
          <SummaryAmountGrid item xs={4} key={`summary-box-${index}`}>
            <SummaryAmountBox>
              <Typography variant="caption">{item.title}</Typography>
              <Typography variant="h6">{item.amount}</Typography>
            </SummaryAmountBox>
          </SummaryAmountGrid>
        ))}
      </Grid>
    </Box>
  );
};

export default SummaryNumberInOut;

const SummaryAmountBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: 16
}));

const SummaryAmountGrid = styled(Grid)({
  borderRight: '1px solid lightgray',
  '&:last-child': {
    borderRight: 'none'
  }
});
